import { Card, CardContent } from "@mui/material";
import { Box } from "@mui/system";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const AimBanner = () => {
  const [ref, inView] = useInView();
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: 520,
        paddingX: 1,
        width: "100%",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundImage: "url('/images/aimBg.png')",
          backgroundSize: "cover",
          opacity: 0.4,
        },
      }}
    >
      <Card
        sx={{
          width: { sm: "90%", md: "70%" },
          marginX: "auto",
          position: "relative",
          top: 200,
          borderRadius: 12,
          borderColor: "#1F1F1F",
          borderWidth: 2,
          bgcolor: "#171719",
        }}
      >
        <CardContent>
          <div className="md:m-5 font-HNthin text-white text-2xl md:text-5xl bg-[url('assets/images/aimbg.png')] bg-center bg-no-repeat text-opacity-90">
            OUR AIM
          </div>
          <div
            className="font-HNlight text-neutral-400
md:text-xl
leading-tight m-3 md:m-8 "
          >
            At V Pack, we're dedicated to pushing the boundaries of Bottle Cap
            solutions through cutting-edge technology and a passionate team. Our
            mission is to set new standards by continually enhancing speed,
            knowledge, and quality. With an unwavering commitment to excellence,
            we craft top-tier bottles, ensuring your brand stands out with
            innovation and unparalleled craftsmanship. Join us to experience the
            future of Bottle Caps.
          </div>
          <motion.div
            ref={ref}
            initial={{ y: 40 }}
            animate={{ y: inView ? 0 : 40 }}
            transition={{ type: "spring", bounce: 1, damping: 5 }}
            className="flex md:flex-row justify-center flex-wrap items-center "
          >
            <div className="flex flex-col w-28 md:w-32 h-32 md:h-40 p-4 bg-gradient-to-b from-green-600 to-transparent rounded-[35px] shadow items-center m-2 justify-center">
              {" "}
              <img
                height={50}
                src={require("../../assets/images/aimicon1.png")}
                alt="bottle cap"
              />
              <p className="text-white text-sm font-normal font-HNlight p-1">
                Timely Delivery
              </p>
            </div>
            <div className="flex flex-col w-28 md:w-32 h-32 md:h-40 p-4 bg-gradient-to-b from-green-600 to-transparent rounded-[35px] shadow items-center mx-2 justify-center">
              {" "}
              <img
                height={50}
                src={require("../../assets/images/aimicon2.png")}
                alt="bottle cap"
              />
              <p className="text-white text-sm font-normal font-HNlight p-1">
                Quality Products
              </p>
            </div>
            <div className="flex flex-col w-28 md:w-32 h-32 md:h-40 p-4 bg-gradient-to-b from-green-600 to-transparent rounded-[35px] shadow items-center mx-2  justify-center">
              {" "}
              <img
                height={50}
                src={require("../../assets/images/aimicon3.png")}
                alt="bottle cap"
              />
              <p className="text-white text-sm font-normal font-HNlight p-1">
                Customer Satisfaction
              </p>
            </div>
            <div className="flex flex-col w-28 md:w-32 h-32 md:h-40 p-4 bg-gradient-to-b from-green-600 to-transparent rounded-[35px] shadow items-center mx-2 justify-center">
              {" "}
              <img
                src={require("../../assets/images/aimicon4.png")}
                height={50}
                alt="bottle cap"
              />
              <p className="text-white text-sm font-normal font-HNlight p-1">
                Passion for Excellence
              </p>
            </div>
          </motion.div>
        </CardContent>
      </Card>
    </Box>
  );
};
export default AimBanner;
